function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import { string, bool, node, func } from 'prop-types';
import Form from "semantic-ui-react/dist/es/collections/Form/Form.js";
import { Heading } from "../../../../typography/Heading";
import { Modal } from "../../../../elements/Modal";
import { HorizontalGutters } from "../../../../layout/HorizontalGutters";
import { CHECK_OUR_AVAILABILITY } from "../../../../../utils/default-strings";
import { SearchFields } from "../SearchFields";
export var Component = function Component(_ref) {
  var modalSummaryElement = _ref.modalSummaryElement,
      modalHeadingText = _ref.modalHeadingText,
      isModalOpen = _ref.isModalOpen,
      searchButton = _ref.searchButton,
      onSubmit = _ref.onSubmit,
      searchFieldsProps = _objectWithoutProperties(_ref, ["modalSummaryElement", "modalHeadingText", "isModalOpen", "searchButton", "onSubmit"]);

  var _useState = useState(isModalOpen),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return React.createElement(Modal, {
    hasPadding: true,
    header: modalSummaryElement ? modalSummaryElement : React.createElement(Heading, {
      size: "small"
    }, modalHeadingText),
    isFullscreen: true,
    isOpen: isOpen,
    onClose: function onClose() {
      return setIsOpen(false);
    },
    trigger: React.createElement("div", {
      "data-test-id": "search-bar-search-modal-trigger",
      onClick: function onClick() {
        return setIsOpen(true);
      }
    }, searchButton)
  }, React.createElement("div", {
    className: "search-bar is-stackable"
  }, React.createElement(HorizontalGutters, null, React.createElement(Form, {
    onSubmit: onSubmit
  }, React.createElement(SearchFields, searchFieldsProps)))));
};
Component.displayName = 'SearchModal';
Component.defaultProps = {
  modalSummaryElement: null,
  modalHeadingText: CHECK_OUR_AVAILABILITY,
  onSubmit: Function.prototype,
  isModalOpen: false,
  searchButton: React.createElement("div", null)
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  isModalOpen: bool,
  modalHeadingText: string,
  modalSummaryElement: node,
  onSubmit: func,
  searchButton: node
} : {};